export const rangeSeparator = '-'
